export default __webpack_public_path__ + "static/trustlilot-logo-ffb3e0dd60bc36ef417befd4e8de58de.png";